import { Box } from '@mui/material';
import { useDynamicFieldContext } from '../DynamicFieldContext';
import { DynamicFieldChip } from './DynamicFieldChip';
import { memo } from 'react';

/**
 * Pass in normalized string[] values and onRemove handler
 * Normalized strings via SelectedItemsAccordion (normalizeSelectedValues)
 */

type SelectedChipsProps = {
  values: string[];
  onRemove: (value: string) => void;
  disabled?: boolean;
};

export const SelectedChips = memo(
  ({ values = [], onRemove, disabled = false }: SelectedChipsProps) => {
    const { dynamicOptions } = useDynamicFieldContext();

    const handleRemoveChip = (value: string) => {
      onRemove(value);
    };

    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '6px',
        }}
      >
        {values.map((val: string, idx: number) => {
          // Find the label from dynamicOptions by matching the value
          const opt = dynamicOptions?.find((o) => o?.value === val);
          const label = opt?.label || val; // fallback to value if no match
          const reactKey = `key-${val}-${idx}`;
          return (
            <DynamicFieldChip
              key={reactKey}
              idTag="selected"
              value={val}
              label={label}
              onRemove={handleRemoveChip}
              disabled={disabled}
            />
          );
        })}
      </Box>
    );
  },
);
SelectedChips.displayName = 'SelectedChips';
